import APLayout from "../components/ApplicationsPage/APLayout";

const ApplicationsPage = () => {
  return <APLayout />;
};

export default ApplicationsPage;
